// Ses paketleri (veri + sınırsız konuşma & SMS) kataloğu — /v2/bundles?family=voice
//
// Bu paketler eski uçlardan (/countries-data, /regions-data) BİLEREK eleniyor:
// plan şemaları eski RefillResponse modeline uymuyor. Tek erişim yolu /v2/bundles,
// yani sınırsız paketlerdeki desenin aynısı (bkz. docs/ses-paketleri.md).

import { createBundleCatalog } from './bundleCatalog';

const catalog = createBundleCatalog('voice');

export const loadVoiceBundles = catalog.load;
export const resetVoiceBundles = catalog.reset;

// Sınırsız konuşma/SMS sözleşmesi: -1 = sınırsız. Ekranda "-1 dakika" çıkmasın
// diye her yerde bu yardımcıdan geçilir. null/undefined → alan gösterilmez.
export const UNLIMITED = -1;

export const isUnlimitedAllowance = (value) => value === UNLIMITED;

/**
 * Konuşma/SMS hakkını metne çevirir.
 * @param {Function} t - i18next çeviri fonksiyonu
 * @param {number|null|undefined} value - voiceMinutes veya smsCount
 * @param {'voice'|'sms'} kind
 * @returns {string|null} - değer yoksa null (alan hiç gösterilmez)
 */
export const formatAllowance = (t, value, kind) => {
  if (value == null) return null;
  if (isUnlimitedAllowance(value)) {
    return kind === 'voice' ? t('plan.unlimitedCalls') : t('plan.unlimitedSms');
  }
  return kind === 'voice' ? t('plan.minutes', { n: value }) : t('plan.sms', { n: value });
};
